export function launchIOSQuicklook(urlOfUsdz: string): void {
    const link: HTMLAnchorElement = document.createElement('a');
    link.style.display = 'none';
    link.href = urlOfUsdz;
    link.download = 'scene.usdz';
    document.body.appendChild(link);

    // ar links for IOS have to be marked with "ar" and need to contain an image
    link.rel = 'ar'; // required for IOS
    link.innerHTML = '<img src="w-cf/data/core/textures/fallback.png"/>';
    link.click();

    // clean up (delay to prevent error in IOS)
    window.setTimeout(() => {
        document.body.removeChild(link);
        URL.revokeObjectURL(urlOfUsdz);
    });
}

export function launchAndroidModelViewer(urlOfGltf: string): void {
    const location: string = window.location.toString();
    const locationUrl: URL = new URL(location);
    const modelUrl: URL = new URL(urlOfGltf, location);
    const scheme: string = modelUrl.protocol.replace(':', '');

    const intentParams: string = `?file=${encodeURIComponent(modelUrl.toString())}&mode=ar_only&resizable=true`;
    const intent: string = `intent://arvr.google.com/scene-viewer/1.0${intentParams}#Intent;scheme=${scheme};package=com.google.ar.core;action=android.intent.action.VIEW;S.browser_fallback_url=${encodeURIComponent(locationUrl.toString())};end;`;

    const link: HTMLAnchorElement = document.createElement('a');
    link.style.display = 'none';
    link.href = intent;
    document.body.appendChild(link);

    link.click();

    window.setTimeout(() => {
        document.body.removeChild(link);
    });
}